import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
} from "@angular/core";
import { CommonModule } from "@angular/common";

type ButtonVariant =
    | "primary"
    | "secondary"
    | "danger"
    | "success"
    | "info"
    | "warning"
    | "ghost";
type ButtonSize = "sm" | "md" | "lg" | "xl";
type IconPosition = "left" | "right";

@Component({
    selector: "app-button",
    standalone: false,
    templateUrl: "./button.component.html",
})
export class ButtonComponent {
    @Input() variant: ButtonVariant = "primary"; //cor do botão
    @Input() size: ButtonSize = "md"; //tamanho do botão
    @Input() disabled = false; //desabilitar o botão
    @Input() loading = false; //estado de carregamento, pode ser usado para mostrar um spinner ou desabilitar o botão
    @Input() fullWidth = true; // tamanho da largura do botão
    @Input() type: "button" | "submit" | "reset" = "button"; //tipo do botão
    @Input() icon: string = ""; //classe do ícone (ex: "fa fa-plus")
    @Input() iconPosition: IconPosition = "left"; //posição do ícone
    @Input() maxHeight: boolean = true; // Aplicar altura máxima de 40px

    // button.component.ts
    @ViewChild("pessoa", { static: false, read: ElementRef })
    public buttonElement!: ElementRef;
    // @Output() clicked = new EventEmitter<void>(); //evento emitido quando o botão é clicado

    @ViewChild("btnNativo", { static: true })
    public btnNativoRef!: ElementRef<HTMLButtonElement>;

    constructor(public el: ElementRef) {}

    get nativeElement(): HTMLElement {
        return this.btnNativoRef?.nativeElement || this.el.nativeElement;
    }

    addEventListener(event: string, callback: any) {
        this.nativeElement.addEventListener(event, callback);
    }

    get classes(): string {
        //     const base = `
        //   inline-flex items-center justify-center
        //   font-medium rounded-lg shadow-md
        //   cursor-pointer
        //   transition-all duration-200 ease-in-out
        //   focus:outline-none focus:ring-2 focus:ring-offset-2
        //   active:translate-y-0 active:shadow-sm
        //   disabled:opacity-50 disabled:cursor-not-allowed
        //   disabled:hover:translate-y-0 disabled:hover:shadow-md
        // `;

        //     const variants: Record<ButtonVariant, string> = {
        //       primary: 'bg-primary text-white hover:bg-primary-hover focus:ring-primary',
        //       secondary: 'bg-slate-100 text-primary hover:bg-slate-200 focus:ring-primary border-2 border-primary',
        //       danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
        //       ghost: 'bg-transparent text-blue-600 hover:bg-blue-50 focus:ring-blue-400',
        //     };
        
        const height = this.maxHeight ? "h-8" : "max-h-auto"; // ← aplicar altura máxima

        const base = `
      inline-flex items-center justify-center cursor-pointer
      font-medium rounded-lg
      shadow-md
      transition-all duration-200 ease-in-out
      focus:outline-none focus:ring-2 focus:ring-offset-2
      active:translate-y-0 active:shadow-sm
      disabled:opacity-50 disabled:cursor-not-allowed
      disabled:hover:translate-y-0 disabled:hover:shadow-md
    `;

        const variants: Record<ButtonVariant, string> = {
            primary: `
        bg-primary text-white
        hover:-translate-y-1 hover:bg-primary-hover shadow-xl hover:shadow-primary-hover/60
        focus:ring-primary
      `,
            secondary: `
        bg-slate-100 text-primary border-2 border-primary
        hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/50
        focus:ring-primary
      `,
            danger: `
        bg-red-600 text-white
        hover:-translate-y-1 hover:shadow-xl hover:shadow-red-500/50
        focus:ring-red-500
      `,
            success: `
        bg-green-600 text-white
        hover:-translate-y-1 hover:shadow-xl hover:shadow-green-500/50
        focus:ring-green-500
      `,
            info: `
        bg-sky-600 text-white
        hover:-translate-y-1 hover:shadow-xl hover:shadow-sky-500/50
        focus:ring-sky-500
      `,
            warning: `
        bg-yellow-400 text-white
        hover:-translate-y-1 hover:shadow-xl hover:shadow-yellow-300/50
        focus:ring-yellow-400
      `,
            ghost: `
        bg-transparent text-primary
        hover:-translate-y-1 hover:shadow-md hover:shadow-primary/30
        focus:ring-primary
        border-primary
        border-2
      `,
        };

        const sizes: Record<ButtonSize, string> = {
            sm: "text-sm px-3 py-0 gap-1.5", //tamanho pequeno
            md: "text-base px-4 py-1 gap-2", //tamanho médio
            lg: "text-base px-6 py-3 gap-2", //tamanho grande
            xl: "text-base px-6 py-3 gap-2", //tamanho extra
        };

        const width = this.fullWidth ? "w-full" : "w-auto"; // ← aplicar largura

        return `${base} ${variants[this.variant]} ${sizes[this.size]} ${width} ${height}`;
    }
}
